<div class="main-container d-flex flex-column flex-md-row justify-content-center text-center text-md-start" >
  <img
    src="assets/images/page_not_found_image.png"
    alt="not-found"
    class="mt-5 mb-4 mb-md-0 me-md-5 img-fluid align-self-center"
    style="max-width: 300px;"
  />
  <div class="d-flex flex-column my-auto">
    <p class="parrafo1">ERROR</p>
    <p class="parrafo2">404</p>
    <p class="parrafo3">Página no encontrada</p>
  </div>
</div>
